export default __webpack_public_path__ + "static/media/cc.9cfc9848.svg";